import React from 'react';
import styled from 'styled-components';

import UnstyledList from '~/components/styled-components/UnstyledList';

export const StyledLink = styled.a`
  color: #4b4b4b;
  font-size: 14px;
  text-decoration: none;
  padding-block: 4px;
  box-sizing: border-box;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    text-decoration: underline double;
    outline: none;
  }
`;

/**
 * @typedef {import('./types').FooterLink} FooterLink
 *
 * Renders a list of links
 * @param {object} props
 * @param {FooterLink[]} props.links
 */
export const CategoryLinksList = ({ links }) => {
  return (
    <UnstyledList>
      {links.map((link) => (
        <li key={link.analyticsId}>
          <StyledLink href={link.href} daa-ll={link.analyticsId} target="_blank">
            {link.label}
          </StyledLink>
        </li>
      ))}
    </UnstyledList>
  );
};
